$(document).ready(function(){ 
  $('.product-description-full').hide(); 
  $('.readmore').click(function (event) { 
    event.preventDefault(); 
    $('.product-description-full').show(); 
    $('.product-description-short').hide(); 
    $('.readmore').toggleClass('readless'); 
  }); 
  $('.readless').click(function (event) { 
    event.preventDefault(); 
    $('.product-description-full').hide(); 
    $('.product-description-short').show(); 
    $('.readmore').toggleClass('readless'); 
  }); 
});
